import { make } from 'vuex-pathify'

const STORAGE_KEY = 'app-theme'
function getInitialMode () {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved) return saved

  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  return prefersDark ? 'dark' : 'light'
}

export default {
  namespaced: true,
  state: {
    mode: getInitialMode(),
  },

  actions: {
    ...make.actions('mode'),
    toggle ({ state, commit }) {
      const next = state.mode === 'dark' ? 'light' : 'dark'
      commit('SET_MODE', next)
      localStorage.setItem(STORAGE_KEY, next)
    }
  },

  mutations: {
    ...make.mutations('mode')
  },
}
